/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Navigation.css';
import Messages from './Messages';
import NavigationButton from '../NavigationButton';
import NavigationSmallButton from '../NavigationSmallButton';

import { getAlertsCount } from '../../actions/AlertsActions';
import { getAdminButtons , getUserButtons } from './NavigationButtonsValues';
import { isPriviliged } from '../../core/deviceHelper';
import { getProfileNumber } from '../../core/navigationHelper';

const ALERTS_NUMBER_CHECK_INTERVAL = 30 * 1000; //  50 * 1000; 

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    let value = 'device_list_header_text';
    const pathname = this.props.pathname;
    if (pathname === '/profile') {
      value = 'profile_settings_header_text';
    } else if (pathname === '/messages') {
      value = 'basic_navigation_messages';
    } else if (pathname === '/notifications') {
      value = 'basic_navigation_messages';
    } else if (pathname === '/newdevice') {
      value = 'add_new_device_submit_main_screen_text';
    }
    this.state = {
      value,
    };
  }

  componentWillUpdate(newProps) {
    const alertsCount = this.props.alertsCount;
    const newAlertsCount = newProps.alertsCount;
    if (
      alertsCount.get('unseenMessages') < newAlertsCount.get('unseenMessages')
      || alertsCount.get('unseenAlerts') < newAlertsCount.get('unseenAlerts')) {
    }
  }

  componentDidMount() {
    this.startCheckingNewAlerts();
  }

  componentWillUnmount() {
    this.stopCheckingNewAlerts();
  }

  setTextValue = value => {
    this.setState({
      value,
    });
  };

  checkForNewAlerts = () => {
    if (this.props.alertsCount.get('requestInProgress') === false) {
      this.props.getAlertsCount();
    }
  };

  startCheckingNewAlerts = () => {
    if (this.intervalId) {
      return;
    }
    this.checkForNewAlerts();
    this.intervalId = window.setInterval(
      this.checkForNewAlerts,
      ALERTS_NUMBER_CHECK_INTERVAL
    );
  };

  stopCheckingNewAlerts = () => {
    window.clearInterval(this.intervalId);
    this.intervalId = null;
  };

  render() {
    const messages = Messages();
    const { userRole, producent, ownershipCount, personalData } = this.props;
    const isSuperior = producent === 'spirotech';
    const titleWrapper = isSuperior
      ? cx(s.headerText, s.spirotech)
      : cx(s.headerText);
    const buttons = isPriviliged(userRole)
      ? getAdminButtons(false, producent, ownershipCount)
      : getUserButtons(false, producent, ownershipCount);
    const buttonsSmall = isPriviliged(userRole)
      ? getAdminButtons(true, producent, ownershipCount)
      : getUserButtons(true, producent, ownershipCount);
    const profileNumber = getProfileNumber(personalData);
    if (userRole !== null) {
      return (
        <div>
          <div className={s.root}>
            {buttons.map((item, index) => 
              <NavigationButton
                key={item.text}
                iconName={item.iconName}
                message={messages[item.text]}
                alertsCount={this.props.alertsCount}
                link={item.link}
                profileNumber={profileNumber}
              />
            )}
          </div>
          <div className={s.rootSmall}>
            {buttonsSmall.map((item, index)  => 
              <NavigationSmallButton
                key={item.text}
                item={item}
                alertsCount={this.props.alertsCount}
                active={this.state.value}
                producent={producent}
                setTextValue={this.setTextValue}
                userRole={userRole}
                ownershipCount={ownershipCount}
                profileNumber={profileNumber}
              />
            )}
            <div className={titleWrapper}>
              <span className={s.center}>
                <FormattedMessage {...messages[this.state.value]} />
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapState = state => ({
  alertsCount: state.alertsCount,
  personalData: state.profilePersonalData,
  alertsPaging: state.alertsPaging,
});

Navigation.propTypes = {
  userRole: PropTypes.number,
  getAlertsCount: PropTypes.func.isRequired,
  alertsCount: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  alertsPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  producent: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  personalData: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  ownershipCount: PropTypes.number.isRequired,
};

Navigation.defaultProps = {
  userRole: null,
}

const mapDispatch = dispatch => {
  return {
    getAlertsCount: () => dispatch(getAlertsCount()),
  };
};

export default compose(withStyles(s), connect(mapState, mapDispatch))(
  Navigation
);



// WEBPACK FOOTER //
// ./src/components/BasicNavigation/Navigation.js